import { render, staticRenderFns } from "./w-icon.vue?vue&type=template&id=6c49e7dc&"
import script from "./w-icon.vue?vue&type=script&lang=ts&"
export * from "./w-icon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports